import module from 'empresa/module.js'

export const schema = {}

export default class EmpresaAvatarService {
  constructor ($http) {
    this.$http = $http
  }

  get (empresaId, size) {
    return this.$http.get('/api/empresa/avatar', {
      params: {empresa_id: empresaId, size: size | 2},
      responseType: 'blob',
    })
  }

  post (empresaId, file) {
    let formData = new global.FormData()
    formData.append('archivo', file)

    return this.$http.post('/api/empresa/avatar', formData, {
      params: {empresa_id: empresaId},
    })
  }
}

module.service('EmpresaAvatar', EmpresaAvatarService)



// WEBPACK FOOTER //
// ./src/empresa/services/Empresa/Avatar.js